import { SvelteMap, SvelteSet } from "svelte/reactivity";
const storageKeyPrefix = "sns_functions_";
export class SnsFunctions {
    _functionsMap;
    _loaded;
    constructor() {
        this._functionsMap = new SvelteMap();
        this._loaded = new SvelteSet();
    }
    get(snsCanisterId) {
        if (!this._loaded.has(snsCanisterId)) {
            this.fromStorage(snsCanisterId);
        }
        return this._functionsMap.get(snsCanisterId);
    }
    set(snsCanisterId, list) {
        const functions = new Map(list.map((f) => [f.id, f]));
        this._functionsMap.set(snsCanisterId, functions);
        this.toStorage(snsCanisterId);
    }
    clone() {
        const clone = new SnsFunctions();
        clone._functionsMap = new Map(this._functionsMap);
        clone._loaded = new Set(this._loaded);
        return clone;
    }
    fromStorage(snsCanisterId) {
        const json = localStorage.getItem(storageKeyPrefix + snsCanisterId);
        if (json !== null) {
            this._functionsMap.set(snsCanisterId, new Map(JSON.parse(json)));
        }
        this._loaded.add(snsCanisterId);
    }
    toStorage(snsCanisterId) {
        const functions = this._functionsMap.get(snsCanisterId);
        if (functions === undefined) {
            return;
        }
        localStorage.setItem(storageKeyPrefix + snsCanisterId, JSON.stringify([...functions]));
    }
}
